



























































































































































































import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import * as s_Interface from '@/interface/store/manageGroups';

const namespace: string = 'inventory';

@Component
export default class FixedItem extends Vue {
  @PropSync('name', { type: String }) syncedItemName!: any;
  @PropSync('requestedBy', { type: String, default: '' }) syncedRequestedBy?: String;
  @PropSync('ownedBy', { type: String, default: '' }) syncedOwnedBy?: String;

  @Prop({ type: Object, default: {} }) currentItem!: any;
  @Prop({ type: String, default: '' }) currentActiveName!: any;
  @Prop({ type: String, default: '' }) refItem!: any;
  @Prop({ type: Array, default: () => [] }) labelSet!: any;
  @Prop({ type: String, default: '' }) itemId!: String;

  @Action('updateRequestStatus', { namespace: 'request' }) c_updateRequestStatus!: any;
  @Action('bulkSetRequest', { namespace: 'request' }) c_bulkSetRequest!: any;
  @Action('updateRequest', { namespace: 'request' }) c_updateRequest!: any;
  @Action('getSettings', { namespace: 'manageGroup' }) c_getSettings!: any;

  @Getter('getterMembers', { namespace: 'manageGroup' }) c_getterMembers!: Array<
    s_Interface.Member
  >;
  @Getter('getterMe', { namespace: 'manageGroup' }) c_getterMe!: s_Interface.Member;
  @Getter('getterSettings', { namespace: 'manageGroup' })
  c_getterSettings!: s_Interface.SettingResponse;

  public initOwner: string = '';
  public inventoryValue: string = '';
  public inventoryOptions: any = [
    { label: '복사', value: 'duplicate' },
    { label: '삭제', value: 'delete' },
  ];
  public requestValue: string = '';
  public requestOptions: Array<object> = [
    {
      label: '재구매요청',
      value: 'PENDING',
      show: ['PENDING', 'APPROVED', 'ORDERED', 'BACKORDERED', 'CANCELLED'],
    },
    {
      label: '발주서 생성',
      value: 'ORDERDRAFT',
      show: ['PENDING', 'APPROVED', 'ORDERED', 'BACKORDERED', 'RECEIVED', 'CANCELLED'],
    },
    {
      label: '이전상태로 변경',
      value: 'REVERT',
      show: ['APPROVED', 'ORDERED', 'BACKORDERED', 'RECEIVED', 'CANCELLED'],
    },
    { label: '배송지연', value: 'BACKORDERED', show: ['ORDERED'] },
    {
      label: '취소',
      value: 'CANCELLED',
      show: ['PENDING', 'APPROVED', 'ORDERED', 'BACKORDERED'],
    },
  ];
  public statusList: Array<object> = [
    { label: '승인', value: 'PENDING', next: 'APPROVED' },
    { label: '주문', value: 'APPROVED', next: 'ORDERED' },
    { label: '수령', value: 'ORDERED', next: 'RECEIVED' },
    { label: '재구매요청', value: 'RECEIVED', next: 'PENDING' },
    { label: '취소됨', value: 'CANCELLED', next: 'CANCELLED' },
    { label: '수령', value: 'BACKORDERED', next: 'RECEIVED' },
  ];
  public revertList: Array<object> = [
    { label: '요청상태', value: 'APPROVED', prev: 'PENDING' },
    { label: '승인상태', value: 'ORDERED', prev: 'APPROVED' },
    { label: '주문상태', value: 'RECEIVED', prev: 'ORDERED' },
    { label: '승인상태', value: 'BACKORDERED', prev: 'APPROVED' },
    { label: '요청상태', value: 'CANCELLED', prev: 'PENDING' },
  ];

  // async created() {
  //   await this.c_getSettings(this.$route.params.groupId);
  // }

  mounted() {
    // element ui textarea의 css를 커스텀 적용해야하는데 방법을 찾지 못해 어쩔 수 없이
    // 엘리먼트 가져와서 강제로 스타일 주입
    const elTextArea = document.getElementsByClassName('el-textarea__inner')[0] as HTMLElement;
    elTextArea.style.border = 'solid 1px transparent';
    elTextArea.style.resize = 'none';
    elTextArea.style.paddingLeft = '0';
    elTextArea.style.paddingRight = '24px';
    elTextArea.style.cursor = 'pointer';
    elTextArea.style.fontWeight = 'bold';
  }

  // 물품명 textarea내 에서 엔터키의 동작을 막기 위한 함수
  onEnter(e: any) {
    e.stopPropagation();
    e.preventDefault();
    e.returnValue = false;
    this.syncedItemName = e.target.value;
  }

  get requestOptionFilter() {
    if (this.c_getterMe.isAdmin) {
      return this.requestOptions.filter((opt: any) =>
        opt.show.find((item: any) => item === this.currentItem.status)
      );
    } else {
      let memberFilteredOptions = this.requestOptions
        .filter((opt: any) => opt.show.find((item: any) => item === this.currentItem.status))
        .filter((opt: any) => opt.value !== 'REVERT');
      if (this.c_getterMe.fkUser.id === this.currentItem.requestedBy) {
        if (this.currentItem.status !== 'PENDING') {
          memberFilteredOptions = memberFilteredOptions.filter(
            (opt: any) => opt.value !== 'CANCELLED'
          );
        }
      } else {
        memberFilteredOptions = memberFilteredOptions.filter(
          (opt: any) => opt.value !== 'CANCELLED'
        );
      }
      return memberFilteredOptions;
    }
  }

  get presentStatus() {
    return this.statusList.find((opt: any) => opt.value === this.currentItem.status);
  }

  // 각각의 재고 아이템 클릭 시 등록자 정보 업데이트하기 위함
  @Watch('itemId')
  onItemId(c: any, p: any) {
    if (this.currentItem.hasOwnProperty('fkOwnedBy')) {
      this.initOwner = this.currentItem.fkOwnedBy.fullName;
    } else if (this.currentItem.hasOwnProperty('fkRequestedBy')) {
      this.initOwner = this.currentItem.fkRequestedBy.fullName;
    }
  }

  get itemWriter() {
    if (this.currentItem.hasOwnProperty('fkOwnedBy')) {
      if (this.initOwner == null || this.initOwner === '') {
        this.initOwner = this.currentItem.fkOwnedBy.fullName;
      }
    }
    if (this.currentItem.hasOwnProperty('fkRequestedBy')) {
      if (this.initOwner == null || this.initOwner === '') {
        this.initOwner = this.currentItem.fkRequestedBy.fullName;
      }
    }
    return this.initOwner;
  }

  get activeMembers() {
    return this.c_getterMembers.filter((member) => member.status == 'ACTIVE');
  }

  ownedSelect(f: any) {
    const stringArray: any = f.split('_');
    this.initOwner = stringArray[1];
    if (this.syncedRequestedBy) this.syncedRequestedBy = stringArray[2];
    else if (this.syncedOwnedBy) this.syncedOwnedBy = stringArray[2];
  }

  activeTab(item: any) {
    const wrapper: any = document.querySelector(this.refItem);
    const el: any = document.querySelector(`#${item.value}`);
    const elTop: number = el.offsetTop - 237;

    wrapper.scrollTop = elTop;

    this.labelSet.forEach((v: any) => (v.isActive = v.value === item.value));
  }

  async statusChange(status: string) {
    const item = this.currentItem;
    const groupId: string = this.$route.params.groupId;
    const statusPayload: any = [];
    switch (status) {
      case 'APPROVED':
        this.$confirm('이 물품을 구매승인 하시겠습니까?', '구매승인', {
          confirmButtonText: '승인',
          cancelButtonText: '취소',
          type: 'success',
        })
          .then(async () => {
            try {
              statusPayload.push({
                ...item,
                notes: null,
                status,
              });
              if (this.c_getterMe) {
                await this.c_updateRequestStatus({
                  groupId,
                  payload: statusPayload,
                });
                this.$emit('emitHandleClose');
                this.$message.success('구매승인 하였습니다.');
              }
            } catch (e) {
              console.log(e);
              this.$message.error(e.response.data.error.message);
            }
          })
          .catch((e: Error) => {
            console.log(e);
          });
        break;
      case 'ORDERED':
        statusPayload.push({
          id: item.id,
          name: item.name,
          price: item.price,
          status,
        });
        this.$emit('emitOrderStatus', statusPayload);
        break;
      case 'RECEIVED':
        statusPayload.push({
          id: item.id,
          name: item.name,
          catalogNumber: item.catalogNumber,
          fkVendorId: item.fkVendorId,
          fkManufacturerId: item.fkManufacturerId,
          fkTypeId: item.fkTypeId,
          status,
          notes: item.notes,
          price: item.price,
          quantity: item.quantity,
          quantityReceived: item.quantityReceived,
          unit: item.unit,
          unitSize: item.unitSize,
          url: item.url,
          addToInventory: true,
          isNewItem: true,
          fkLocationId: null,
          fkLocationSubId: null,
          fkInventoryId: item.fkInventoryId,
          fkInventory: item.fkInventory,
        });
        this.$emit('emitOrderStatus', statusPayload);
        break;
      case 'BACKORDERED':
        statusPayload.push({
          id: item.id,
          name: item.name,
          expectedOn: item.expectedOn,
          status,
        });
        this.$emit('emitOrderStatus', statusPayload);
        break;
      case 'PENDING':
        this.$confirm(`물품을 재구매요청 하시겠습니까?`, '재구매요청', {
          confirmButtonText: `재구매요청`,
          cancelButtonText: '취소',
          type: 'success',
        })
          .then(async () => {
            try {
              statusPayload.push(item);
              const payload = statusPayload.map((v: any) => {
                return {
                  requestedBy: this.c_getterMe.fkUser.id,
                  status,
                  catalogNumber: v.catalogNumber ? v.catalogNumber : null,
                  name: v.name,
                  url: v.url,
                  unitSize: v.unitSize,
                  quantity: v.quantity,
                  price: v.price,
                  fkTypeId: v.fkTypeId,
                  fkVendorId: v.fkVendorId ? v.fkVendorId : null,
                  fkManufacturerId: v.fkManufacturerId ? v.fkManufacturerId : null,
                  vendorName: v.fkVendorId ? v.fkVendor.name : null,
                  manufacturerName: v.fkManufacturerId ? v.fkManufacturer.name : null,
                  typeName: v.fkType.name,
                };
              });
              await this.c_bulkSetRequest({
                groupId,
                payload,
              });
              this.$emit('emitHandleClose');
              this.$message.success('재구매요청 하였습니다.');
            } catch (e) {
              console.log(e);
              this.$message.error(e.response.data.error.message);
            }
          })
          .catch((e: Error) => {
            console.log(e);
          });
        break;
      case 'CANCELLED':
        this.$prompt('이 물품에 대한 구매요청을 취소하시겠습니까?', '구매요청 취소', {
          confirmButtonText: '확인',
          cancelButtonText: '취소',
          inputPlaceholder: '코멘트 남기기',
        })
          .then(async ({ value }: any) => {
            try {
              statusPayload.push({
                id: item.id,
                comment: value,
                status,
                requestedBy: item.requestedBy,
              });
              if (this.c_getterMe) {
                await this.c_updateRequestStatus({
                  groupId,
                  payload: statusPayload,
                });
                this.$emit('emitHandleClose');
              }
              this.$message.success('구매요청을 취소하였습니다.');
            } catch (e) {
              console.log(e);
              this.$message.error(e.response.data.error.message);
            }
          })
          .catch((e: Error) => {
            console.log(e);
          });
        break;
      case 'REVERT':
        const revertStatus: any = this.revertList.find(
          (status: any) => status.value === item.status
        );
        this.$confirm(`물품을 ${revertStatus.label}로 변경 하시겠습니까?`, '이전상태로 변경', {
          confirmButtonText: `${revertStatus.label}로 변경`,
          cancelButtonText: '취소',
          type: 'success',
        })
          .then(async () => {
            const groupId: string = this.$route.params.groupId;
            try {
              await this.c_updateRequest({
                groupId,
                requestId: item.id,
                payload: {
                  status: revertStatus.prev,
                },
              });
              this.$message.success('이전상태로 변경하였습니다.');
              this.$emit('emitHandleClose');
            } catch (e) {
              console.log(e);
              this.$message.error(e.response.data.error.message);
            }
          })
          .catch((e) => {
            console.log(e);
          });
        break;
      case 'ORDERDRAFT':
        this.$confirm(`물품을 발주서 생성 하시겠습니까?`, '발주서 생성', {
          confirmButtonText: `발주서 생성`,
          cancelButtonText: '취소',
          type: 'success',
        })
          .then(async () => {
            try {
              const groupId: string = this.$route.params.groupId;
              await this.$router.push({
                path: `/groups/${groupId}/order-draft`,
                query: {
                  items: [item],
                },
              });
            } catch (e) {
              console.log(e);
              this.$message.error(e.response.data.error.message);
            }
          })
          .catch((e) => {
            console.log(e);
          });
        break;
    }
    this.requestValue = '';
  }

  inventorySelect(str: any) {
    switch (str) {
      case 'delete':
        this.$emit('onDelete');
        this.inventoryValue = '';
        break;
      case 'duplicate':
        this.$emit('onDuplicate');
        this.inventoryValue = '';
        break;
    }
  }

  onRequest() {
    this.$emit('onRequest');
  }

  handleClose() {
    this.$emit('handleClose');
  }

  modifyConfirm() {
    if (!!this.syncedRequestedBy) {
      // 구매요청 파트
      if (this.c_getterMe.isAdmin) {
        this.$emit('emitModifyConfirm');
      } else {
        if (this.c_getterMe.fkUser.id === this.currentItem.requestedBy) {
          if (this.currentItem.status === 'PENDING') this.$emit('emitModifyConfirm');
          else this.$message.error('이미 승인된 물품은 관리자만 수정할 수 있습니다.');
          // 등록자는 자신이지만 요청 단계가 아닌 경우
        } else {
          if (this.currentItem.status !== 'RECEIVED') {
            // 요청 단계 포함 어떤 단계이든 요청자가 자신이 아닌 경우
            this.$message.error('요청자와 관리자만 수정가능한 권한이 있습니다.');
          } else {
            this.$emit('emitModifyConfirm');
          }
        }
      }
    } else {
      // 재고관리 파트
      if (this.c_getterSettings.settings.inventoryEdit === 'ALL_EDIT') {
        this.$emit('emitModifyConfirm');
      } else if (this.c_getterSettings.settings.inventoryEdit === 'ADMIN_OWNER') {
        if (this.c_getterMe.isAdmin) this.$emit('emitModifyConfirm');
        else {
          // 멤버인 경우
          if (this.c_getterMe.fkUser.id === this.currentItem.ownedBy) {
            this.$emit('emitModifyConfirm');
          } else {
            // 등록자가 멤버 자신이 아닌 경우
            this.$message.error('등록자와 관리자만 수정가능한 권한이 있습니다.');
          }
        }
      }
    }
  }

  onCopySuccess() {
    this.$message.success('클립보드에 복사하였습니다.');
  }

  onCopyFailure() {
    this.$message.error('클립보드로 복사에 실패하였습니다.');
  }
}
